import tmpls from '../modules/HandlebarsTemplates';

//======================================
//VARIABLES
//
const spotIconListJson = {
  icons: {
    colors: {
      cute: [
        {
          aquaCute: 'aquaCute.png',
          image: 'aquaCute.png',
          name: 'aquaCute',
          className: 'SICaquaCute'
        },
        {
          blueCute: 'blueCute.png',
          image: 'blueCute.png',
          name: 'blueCute',
          className: 'SICblueCute'
        },
        {
          darkPinkCute: 'darkPinkCute.png',
          image: 'darkPinkCute.png',
          name: 'darkPinkCute',
          className: 'SICdarkPinkCute'
        },
        {
          greenCute: 'greenCute.png',
          image: 'greenCute.png',
          name: 'greenCute',
          className: 'SICgreenCute'
        },
        {
          greyCute: 'greyCute.png',
          image: 'greyCute.png',
          name: 'greyCute',
          className: 'SICgreyCute'
        },
        {
          lightPinkCute: 'lightPinkCute.png',
          image: 'lightPinkCute.png',
          name: 'lightPinkCute',
          className: 'SIClightPinkCute'
        },
        {
          lightVioletCute: 'lightVioletCute.png',
          image: 'lightVioletCute.png',
          name: 'lightVioletCute',
          className: 'SIClightVioletCute'
        },
        {
          peachCute: 'peachCute.png',
          image: 'peachCute.png',
          name: 'peachCute',
          className: 'SICpeachCute'
        },
        {
          pinkCute: 'pinkCute.png',
          image: 'pinkCute.png',
          name: 'pinkCute',
          className: 'SICpinkCute'
        },
        {
          skyBlueCute: 'skyBlueCute.png',
          image: 'skyBlueCute.png',
          name: 'skyBlueCute',
          className: 'SICskyBlueCute'
        },
        {
          yellowCute: 'yellowCute.png',
          image: 'yellowCute.png',
          name: 'yellowCute',
          className: 'SICyellowCute'
        }
      ],
      original: [
        {
          yellowish_green: 'yellowish_green.png',
          image: 'yellowish_green.png',
          name: 'yellowish_green',
          className: 'SICyellowish_green'
        },
        {
          dark_green: 'dark_green.png',
          image: 'dark_green.png',
          name: 'dark_green',
          className: 'SICdark_green'
        },
        {
          green: 'green.png',
          image: 'green.png',
          name: 'green',
          className: 'SICgreen'
        },
        {
          light_yellow: 'light_yellow.png',
          image: 'light_yellow.png',
          name: 'light_yellow',
          className: 'SIClight_yellow'
        },
        {
          yellow: 'yellow.png',
          image: 'yellow.png',
          name: 'yellow',
          className: 'SICyellow'
        },
        {
          light_brown: 'light_brown.png',
          image: 'light_brown.png',
          name: 'light_brown',
          className: 'SIClight_brown'
        },
        {
          dark_brown: 'dark_brown.png',
          image: 'dark_brown.png',
          name: 'dark_brown',
          className: 'SICdark_brown'
        },
        {
          brown: 'brown.png',
          image: 'brown.png',
          name: 'brown',
          className: 'SICbrown'
        },
        {
          dark_orange: 'dark_orange.png',
          image: 'dark_orange.png',
          name: 'dark_orange',
          className: 'SICdark_orange'
        },
        {
          light_orange: 'light_orange.png',
          image: 'light_orange.png',
          name: 'light_orange',
          className: 'SIClight_orange'
        },
        {
          orange: 'orange.png',
          image: 'orange.png',
          name: 'orange',
          className: 'SICorange'
        },
        {
          red: 'red.png',
          image: 'red.png',
          name: 'red',
          className: 'SICred'
        },
        {
          pink: 'pink.png',
          image: 'pink.png',
          name: 'pink',
          className: 'SICpink'
        },
        {
          dark_pink: 'dark_pink.png',
          image: 'dark_pink.png',
          name: 'dark_pink',
          className: 'SICdark_pink'
        },
        {
          light_pruple: 'light_pruple.png',
          image: 'light_pruple.png',
          name: 'light_pruple',
          className: 'SIClight_pruple'
        },
        {
          purple: 'purple.png',
          image: 'purple.png',
          name: 'purple',
          className: 'SICpurple'
        },
        {
          dark_purple: 'dark_purple.png',
          image: 'dark_purple.png',
          name: 'dark_purple',
          className: 'SICdark_purple'
        },
        {
          skyblue: 'skyblue.png',
          image: 'skyblue.png',
          name: 'skyblue',
          className: 'SICskyblue'
        },
        {
          blue: 'blue.png',
          image: 'blue.png',
          name: 'blue',
          className: 'SICblue'
        },
        {
          light_blue: 'light_blue.png',
          image: 'light_blue.png',
          name: 'light_blue',
          className: 'SIClight_blue'
        },
        {
          dark_blue: 'dark_blue.png',
          image: 'dark_blue.png',
          name: 'dark_blue',
          className: 'SICdark_blue'
        },
        {
          white: 'white.png',
          image: 'white.png',
          name: 'white',
          className: 'SICwhite'
        },
        {
          dark_gray: 'dark_gray.png',
          image: 'dark_gray.png',
          name: 'dark_gray',
          className: 'SICdark_gray'
        },
        {
          gray: 'gray.png',
          image: 'gray.png',
          name: 'gray',
          className: 'SICgray'
        },
        {
          black: 'black.png',
          image: 'black.png',
          name: 'black',
          className: 'SICblack'
        }
      ]
    }
  },
  genres: {
    gourmet: [
      {
        chopsticks: 'chopsticks.png',
        image: 'chopsticks.png'
      },
      {
        gourmet: 'gourmet.png',
        image: 'gourmet.png'
      },
      {
        rice: 'rice.png',
        image: 'rice.png'
      },
      {
        riceBall: 'riceBall.png',
        image: 'riceBall.png'
      },
      {
        sushi: 'sushi.png',
        image: 'sushi.png'
      },
      {
        seafood: 'seafood.png',
        image: 'seafood.png'
      },
      {
        curry: 'curry.png',
        image: 'curry.png'
      },
      {
        don: 'don.png',
        image: 'don.png'
      },
      {
        salad: 'salad.png',
        image: 'salad.png'
      },
      {
        gyoza: 'gyoza.png',
        image: 'gyoza.png'
      },
      {
        hamburger2: 'hamburger2.png',
        image: 'hamburger2.png'
      },
      {
        hamburger: 'hamburger.png',
        image: 'hamburger.png'
      },
      {
        meatBun: 'meatBun.png',
        image: 'meatBun.png'
      },
      {
        pizza: 'pizza.png',
        image: 'pizza.png'
      },
      {
        croissant: 'croissant.png',
        image: 'croissant.png'
      },
      {
        oden: 'oden.png',
        image: 'oden.png'
      },
      {
        negima: 'negima.png',
        image: 'negima.png'
      },
      {
        steak2: 'steak2.png',
        image: 'steak2.png'
      },
      {
        grilledMeat: 'grilledMeat.png',
        image: 'grilledMeat.png'
      },
      {
        beef: 'beef.png',
        image: 'beef.png'
      },
      {
        meat1: 'meat1.png',
        image: 'meat1.png'
      },
      {
        ramen: 'ramen.png',
        image: 'ramen.png'
      },
      {
        steak: 'steak.png',
        image: 'steak.png'
      },
      {
        spaghetti: 'spaghetti.png',
        image: 'spaghetti.png'
      },
      {
        soba: 'soba.png',
        image: 'soba.png'
      },
      {
        stirFly: 'stirFly.png',
        image: 'stirFly.png'
      },
      {
        cake3: 'cake3.png',
        image: 'cake3.png'
      },
      {
        cake2: 'cake2.png',
        image: 'cake2.png'
      },
      {
        cake1: 'cake1.png',
        image: 'cake1.png'
      },
      {
        iceCream: 'iceCream.png',
        image: 'iceCream.png'
      },
      {
        parfait: 'parfait.png',
        image: 'parfait.png'
      },
      {
        Pancake: 'Pancake.png',
        image: 'Pancake.png'
      },
      {
        juice: 'juice.png',
        image: 'juice.png'
      },
      {
        teaCup: 'teaCup.png',
        image: 'teaCup.png'
      },
      {
        beer: 'beer.png',
        image: 'beer.png'
      },
      {
        sake: 'sake.png',
        image: 'sake.png'
      },
      {
        wine: 'wine.png',
        image: 'wine.png'
      },
      {
        barbecue: 'barbecue.png',
        image: 'barbecue.png'
      },
      {
        bistro: 'bistro.png',
        image: 'bistro.png'
      },
      {
        buffet: 'buffet.png',
        image: 'buffet.png'
      },
      {
        chicken: 'chicken.png',
        image: 'chicken.png'
      },
      {
        chineseCuisine: 'chineseCuisine.png',
        image: 'chineseCuisine.png'
      },
      {
        cocktail: 'cocktail.png',
        image: 'cocktail.png'
      },
      {
        crab: 'crab.png',
        image: 'crab.png'
      },
      {
        crepe: 'crepe.png',
        image: 'crepe.png'
      },
      {
        eel: 'eel.png',
        image: 'eel.png'
      },
      {
        firePot: 'firePot.png',
        image: 'firePot.png'
      },
      {
        horsemeat: 'horsemeat.png',
        image: 'horsemeat.png'
      },
      {
        mutton: 'mutton.png',
        image: 'mutton.png'
      },
      {
        octopus: 'octopus.png',
        image: 'octopus.png'
      },
      {
        okonomiyaki: 'okonomiyaki.png',
        image: 'okonomiyaki.png'
      },
      {
        pork: 'pork.png',
        image: 'pork.png'
      },
      {
        pufferFish: 'pufferFish.png',
        image: 'pufferFish.png'
      },
      {
        shabushabu: 'shabushabu.png',
        image: 'shabushabu.png'
      },
      {
        shrimp: 'shrimp.png',
        image: 'shrimp.png'
      },
      {
        sobaya: 'sobaya.png',
        image: 'sobaya.png'
      },
      {
        softcream: 'softcream.png',
        image: 'softcream.png'
      },
      {
        squid: 'squid.png',
        image: 'squid.png'
      },
      {
        takoyaki: 'takoyaki.png',
        image: 'takoyaki.png'
      },
      {
        tempura: 'tempura.png',
        image: 'tempura.png'
      },
      {
        teppanYaki: 'teppanYaki.png',
        image: 'teppanYaki.png'
      }
    ],
    leasure: [
      {
        volleyball: 'volleyball.png',
        image: 'volleyball.png'
      },
      {
        tennis: 'tennis.png',
        image: 'tennis.png'
      },
      {
        tableTennis: 'tableTennis.png',
        image: 'tableTennis.png'
      },
      {
        basketball: 'basketball.png',
        image: 'basketball.png'
      },
      {
        baseball: 'baseball.png',
        image: 'baseball.png'
      },
      {
        soccer: 'soccer.png',
        image: 'soccer.png'
      },
      {
        rugby: 'rugby.png',
        image: 'rugby.png'
      },
      {
        swimming: 'swimming.png',
        image: 'swimming.png'
      },
      {
        surfing: 'surfing.png',
        image: 'surfing.png'
      },
      {
        snowBord: 'snowBord.png',
        image: 'snowBord.png'
      },
      {
        skiing: 'skiing.png',
        image: 'skiing.png'
      },
      {
        muscle: 'muscle.png',
        image: 'muscle.png'
      },
      {
        movies: 'movies.png',
        image: 'movies.png'
      },
      {
        karaoke: 'karaoke.png',
        image: 'karaoke.png'
      },
      {
        fishing: 'fishing.png',
        image: 'fishing.png'
      },
      {
        bicycle: 'bicycle.png',
        image: 'bicycle.png'
      },
      {
        birthday: 'birthday.png',
        image: 'birthday.png'
      },
      {
        bowling: 'bowling.png',
        image: 'bowling.png'
      },
      {
        golf: 'golf.png',
        image: 'golf.png'
      },
      {
        Stadium: 'Stadium.png',
        image: 'Stadium.png'
      },
      {
        amusementPark: 'amusementPark.png',
        image: 'amusementPark.png'
      },
      {
        tent: 'tent.png',
        image: 'tent.png'
      },
      {
        yoga: 'yoga.png',
        image: 'yoga.png'
      },
      {
        hospital: 'hospital.png',
        image: 'hospital.png'
      },
      {
        building: 'building.png',
        image: 'building.png'
      },
      {
        office: 'office.png',
        image: 'office.png'
      },
      {
        hotel: 'hotel.png',
        image: 'hotel.png'
      },
      {
        bed: 'bed.png',
        image: 'bed.png'
      },
      {
        house: 'house.png',
        image: 'house.png'
      },
      {
        factory: 'factory.png',
        image: 'factory.png'
      },
      {
        fountain: 'fountain.png',
        image: 'fountain.png'
      },
      {
        cut: 'cut.png',
        image: 'cut.png'
      },
      {
        tooth: 'tooth.png',
        image: 'tooth.png'
      },
      {
        salon: 'salon.png',
        image: 'salon.png'
      },
      {
        convenience: 'convenience.png',
        image: 'convenience.png'
      },
      {
        shopping: 'shopping.png',
        image: 'shopping.png'
      },
      {
        money: 'money.png',
        image: 'money.png'
      },
      {
        fashion: 'fashion.png',
        image: 'fashion.png'
      },
      {
        cosmetic: 'cosmetic.png',
        image: 'cosmetic.png'
      },
      {
        lipstick: 'lipstick.png',
        image: 'lipstick.png'
      },
      {
        medicine: 'medicine.png',
        image: 'medicine.png'
      },
      {
        fishing01: 'fishing01.png',
        image: 'fishing01.png'
      },
      {
        fishing02: 'fishing02.png',
        image: 'fishing02.png'
      },
      {
        horseRace: 'horseRace.png',
        image: 'horseRace.png'
      },
      {
        mountainBike: 'mountainBike.png',
        image: 'mountainBike.png'
      }
    ],
    tourism: [
      {
        zoo: 'zoo.png',
        image: 'zoo.png'
      },
      {
        temple: 'temple.png',
        image: 'temple.png'
      },
      {
        school: 'school.png',
        image: 'school.png'
      },
      {
        museum: 'museum.png',
        image: 'museum.png'
      },
      {
        artMuseum: 'artMuseum.png',
        image: 'artMuseum.png'
      },
      {
        aquarium: 'aquarium.png',
        image: 'aquarium.png'
      },
      {
        torii: 'torii.png',
        image: 'torii.png'
      },
      {
        tera: 'tera.png',
        image: 'tera.png'
      },
      {
        castle2: 'castle2.png',
        image: 'castle2.png'
      },
      {
        castle1: 'castle1.png',
        image: 'castle1.png'
      },
      {
        shrine: 'shrine.png',
        image: 'shrine.png'
      },
      {
        tajMahal: 'tajMahal.png',
        image: 'tajMahal.png'
      },
      {
        castle3: 'castle3.png',
        image: 'castle3.png'
      },
      {
        hotSpring: 'hotSpring.png',
        image: 'hotSpring.png'
      },
      {
        festival: 'festival.png',
        image: 'festival.png'
      },
      {
        Monastery: 'Monastery.png',
        image: 'Monastery.png'
      },
      {
        fuji: 'fuji.png',
        image: 'fuji.png'
      },
      {
        river: 'river.png',
        image: 'river.png'
      },
      {
        cave: 'cave.png',
        image: 'cave.png'
      },
      {
        lake: 'lake.png',
        image: 'lake.png'
      },
      {
        forest: 'forest.png',
        image: 'forest.png'
      },
      {
        sakura: 'sakura.png',
        image: 'sakura.png'
      },
      {
        flower: 'flower.png',
        image: 'flower.png'
      },
      {
        beach: 'beach.png',
        image: 'beach.png'
      },
      {
        snowman: 'snowman.png',
        image: 'snowman.png'
      },
      {
        car: 'car.png',
        image: 'car.png'
      },
      {
        taxi: 'taxi.png',
        image: 'taxi.png'
      },
      {
        gasStation: 'gasStation.png',
        image: 'gasStation.png'
      },
      {
        buss: 'buss.png',
        image: 'buss.png'
      },
      {
        train: 'train.png',
        image: 'train.png'
      },
      {
        ship: 'ship.png',
        image: 'ship.png'
      },
      {
        airplane: 'airplane.png',
        image: 'airplane.png'
      },
      {
        serviceArea: 'serviceArea.png',
        image: 'serviceArea.png'
      },
      {
        parking: 'parking.png',
        image: 'parking.png'
      },
      {
        japan: 'japan.png',
        image: 'japan.png'
      },
      {
        italia: 'italia.png',
        image: 'italia.png'
      },
      {
        India: 'India.png',
        image: 'India.png'
      },
      {
        germany: 'germany.png',
        image: 'germany.png'
      },
      {
        china: 'china.png',
        image: 'china.png'
      },
      {
        france: 'france.png',
        image: 'france.png'
      },
      {
        australia: 'australia.png',
        image: 'australia.png'
      },
      {
        Vietnam: 'Vietnam.png',
        image: 'Vietnam.png'
      },
      {
        us: 'us.png',
        image: 'us.png'
      },
      {
        uk: 'uk.png',
        image: 'uk.png'
      },
      {
        thailand: 'thailand.png',
        image: 'thailand.png'
      },
      {
        spain: 'spain.png',
        image: 'spain.png'
      },
      {
        philippines: 'philippines.png',
        image: 'philippines.png'
      },
      {
        korea: 'Korea.png',
        image: 'Korea.png'
      },
      {
        bulletTrain: 'bulletTrain.png',
        image: 'bulletTrain.png'
      },
      {
        farm: 'farm.png',
        image: 'farm.png'
      },
      {
        ranch: 'ranch.png',
        image: 'ranch.png'
      },
      {
        skytree: 'skytree.png',
        image: 'skytree.png'
      },
      {
        tokyotower: 'tokyotower.png',
        image: 'tokyotower.png'
      },
      {
        towerMansion: 'towerMansion.png',
        image: 'towerMansion.png'
      }
    ],
    other: [
      {
        star: 'star.png',
        image: 'star.png'
      },
      {
        heart: 'heart.png',
        image: 'heart.png'
      },
      {
        music: 'music.png',
        image: 'music.png'
      },
      {
        comment: 'comment.png',
        image: 'comment.png'
      },
      {
        exclamationMark: 'exclamationMark.png',
        image: 'exclamationMark.png'
      },
      {
        check: 'check.png',
        image: 'check.png'
      },
      {
        spot: 'spot.png',
        image: 'spot.png'
      },
      {
        human: 'human.png',
        image: 'human.png'
      },
      {
        toilet: 'toilet.png',
        image: 'toilet.png'
      },
      {
        sad: 'sad.png',
        image: 'sad.png'
      },
      {
        Present: 'Present.png',
        image: 'Present.png'
      },
      {
        picture: 'picture.png',
        image: 'picture.png'
      },
      {
        jewelry: 'jewelry.png',
        image: 'jewelry.png'
      },
      {
        hinanjo: 'hinanjo.png',
        image: 'hinanjo.png'
      },
      {
        saigai_kantanhu: 'hinanjo_ken_kinkyuu_hinanjo.png',
        image: 'hinanjo_ken_kinkyuu_hinanjo.png'
      },
      {
        kinkyuu_hinanjo: 'kinkyuu_hinanjo.png',
        image: 'kinkyuu_hinanjo.png'
      },
      {
        saigai_dosha: 'saigai_dosha.png',
        image: 'saigai_dosha.png'
      },
      {
        saigai_jishin: 'saigai_jishin.png',
        image: 'saigai_jishin.png'
      },
      {
        saigai_kantanhu: 'saigai_kantanhu.png',
        image: 'saigai_kantanhu.png'
      },
      {
        saigai_kouzui: 'saigai_kouzui.png',
        image: 'saigai_kouzui.png'
      },
      {
        saigai_tsunami: 'saigai_tsunami.png',
        image: 'saigai_tsunami.png'
      }
    ]
  }
};

let allSpotColorList = [];
_.map(spotIconListJson.icons.colors, colors => {
  allSpotColorList = allSpotColorList.concat(colors);
});
window.allSpotColorList = allSpotColorList;

const SpotIconPrefix = {
  color: 'SIC',
  icon: 'SI'
};
window.SpotIconPrefix = SpotIconPrefix;

//======================================
//EVENTS
//
PopulateSpotIcons();

$(document).on('click', '.spotListChooseIconColor', e => {
  e.preventDefault();
  $('.spotListChooseIconColor').removeClass('active');
  $(e.currentTarget).addClass('active');

  $('#csSpotIconColorPreview').attr(
    'class',
    `csSpotIconColor ${SpotIconPrefix.color}${$(e.currentTarget).data(
      'icondata'
    )}`
  );

  const elm = $('.doChooseSpotIcon');
  elm.data(
    'color-class',
    `csSpotIconColor ${SpotIconPrefix.color}${$(e.currentTarget).data(
      'icondata'
    )}`
  );
  elm.data('color-icondata', $(e.currentTarget).data('icondata'));
});

$(document).on('click', '.spotListChooseIcon', e => {
  e.preventDefault();
  $('.spotListChooseIcon').removeClass('active');
  $(e.currentTarget).addClass('active');

  $('#csSpotIconPreview').attr(
    'class',
    `csSpotIcon ${SpotIconPrefix.icon}${$(e.currentTarget).data('icondata')}`
  );

  const elm = $('.doChooseSpotIcon');
  elm.data(
    'icon-class',
    `csSpotIcon ${SpotIconPrefix.icon}${$(e.currentTarget).data('icondata')}`
  );
  elm.data('icon-icondata', $(e.currentTarget).data('icondata'));
});

$(document).on('click', '.doChooseSpotIcon', e => {
  const colorClass = $(e.currentTarget).data('color-class');
  const colorIconData = $(e.currentTarget).data('color-icondata');
  const iconClass = $(e.currentTarget).data('icon-class');
  const iconIconData = $(e.currentTarget).data('icon-icondata');

  if (colorClass && colorIconData) {
    $('.csSpotIconColor').attr('class', colorClass);
    $('#csSpotIconColor').data('icondata', colorIconData);
    $('.doCancelChooseSpotIcon').data('iconColorData', colorIconData);
  }

  if (iconClass && iconIconData) {
    $('.csSpotIcon').attr('class', iconClass);
    $('#csSpotIcon').data('icondata', iconIconData);
    $('.doCancelChooseSpotIcon').data('iconData', iconIconData);
  }

  $(e.currentTarget).removeAttr('color-class');
  $(e.currentTarget).removeAttr('color-icondata');
  $(e.currentTarget).removeAttr('icon-class');
  $(e.currentTarget).removeAttr('icon-icondata');
});

$(document).on('click', '.doCancelChooseSpotIcon', e => {
  const iconColorData = $(e.currentTarget).data('iconColorData');
  const iconData = $(e.currentTarget).data('iconData');

  $('#csSpotIconColorPreview').attr(
    'class',
    `csSpotIconColor ${SpotIconPrefix.color}${iconColorData}`
  );
  $('#csSpotIconPreview').attr(
    'class',
    `csSpotIcon ${SpotIconPrefix.icon}${iconData}`
  );
  $('.spotListChooseIconColor').removeClass('active');
  $(`.spotListChooseIconColor.SIC${iconColorData}`).addClass('active');
  $('.spotListChooseIcon').removeClass('active');
  $(`.spotListChooseIcon.SI${iconData}Black`).addClass('active');
});

$(document).on('click', '.csSpotIconChoose', e => {
  e.preventDefault();
  if (!$(e.currentTarget).hasClass('disabledElm')) {
    $('.scrollToIconGroup').removeClass('active');
    $('.scrollToIconGroupGenregourmet').addClass('active');
    window.openPopup('#CreateSpotModalSpotIconList');
  }
});

$(document).on('click', '.scrollToIconGroup', e => {
  e.preventDefault();
  $('.scrollToIconGroup').removeClass('active');
  $(e.currentTarget).addClass('active');

  const iconGroupScrollBar = $('.iconGroupScrollBar');
  const scrollElement = iconGroupScrollBar.data('sb')
    ? iconGroupScrollBar.data('sb').getScrollElement()
    : iconGroupScrollBar[0];
  scrollElement.scrollTo({
    left: 0,
    top:
      scrollElement.scrollTop +
      $(`.iconGroupTitleGenere${$(e.currentTarget).data('index')}`).position()
        .top,
    behavior: 'smooth'
  });
});

//======================================
//FUNCTIONS
//
function PopulateSpotIcons() {
  //Append Spot Icon Style Css AND Populate Icons in CreateSpot
  let css = '';
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');

  //====================
  //Add CSS first
  _.map(spotIconListJson.icons.colors, colors => {
    colors.forEach(image => {
      image.name = image.image.replace('.png', '');
      image.className = SpotIconPrefix.color + image.name;

      css += `.${image.className}{background:url("${
        window.SPOTICON_SERVER
      }img/spotIcons/color/${
        image.image
      }") no-repeat; background-size:contain; background-position:center;}\n`;
    });
  });

  //Icons
  _.forEach(spotIconListJson.genres, genre => {
    genre.forEach(image => {
      image.name = image.image.replace('.png', '');
      image.className = SpotIconPrefix.icon + image.name;
      css += `.${image.className}{background:url("${
        window.SPOTICON_SERVER
      }img/spotIcons/white/${
        image.image
      }") no-repeat; background-size:contain; background-position:center;}\n`;
    });
  });

  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  head.appendChild(style);

  //====================
  // Populate
  if ($('#IconColorListTemplate').length <= 0) {
    return;
  }

  const iconGroupScrollBar = $('.iconGroupScrollBar');
  const scrollElement = iconGroupScrollBar.data('sb')
    ? iconGroupScrollBar.data('sb').getScrollElement()
    : iconGroupScrollBar[0];

  scrollElement.addEventListener(
    'scroll',
    _.debounce(() => {
      const bottomMinusHundred = iconGroupScrollBar.height() - 100;
      // eslint-disable-next-line no-mixed-operators
      let className;
      if (bottomMinusHundred > $('.iconGroupTitleGenereother').position().top) {
        className = 'scrollToIconGroupGenreother';
      } else if (
        bottomMinusHundred > $('.iconGroupTitleGeneretourism').position().top
      ) {
        className = 'scrollToIconGroupGenretourism';
      } else if (
        bottomMinusHundred > $('.iconGroupTitleGenereleasure').position().top
      ) {
        className = 'scrollToIconGroupGenreleasure';
      } else {
        className = 'scrollToIconGroupGenregourmet';
      }

      if (
        className &&
        $(`.${className}`).length > 0 &&
        !$(`.${className}`).hasClass('active')
      ) {
        $('.scrollToIconGroup').removeClass('active');
        $(`.${className}`).addClass('active');
      }
    }, 300)
  );

  //Colors
  _.forEach(spotIconListJson.icons.colors, (colors, colorGroupName) => {
    $('.IconColorListTemplateContainer').append(
      `<div class="hideInSP spotColorGroup spotColorGroupTitle${colorGroupName}"></div>`
    );
    colors.forEach(color => {
      $('.IconColorListTemplateContainer').append(
        tmpls.IconColorListTemplate(color)
      );
    });
  });

  const genreJapaneseName = {
    gourmet: window.resolveLang('グルメ'),
    leasure: window.resolveLang('レジャー'),
    tourism: window.resolveLang('観光'),
    other: window.resolveLang('その他')
  };

  //Icons
  _.forEach(spotIconListJson.genres, (genre, genreName) => {
    $('.IconListTemplateContainer').append(
      tmpls.IconGroupTitleTemplate({
        index: genreName,
        name: genreJapaneseName[genreName]
      })
    );
    $('.IconListTemplateContainer').append(tmpls.IconListTemplate(genre));
  });

  //============================
  //set Icon List to center
  const originalPadding = 14;
  const bothPadding = originalPadding * 2;
  const parentWidth = $('html').hasClass('smartPhoneBody')
    ? $('body').width()
    : $('.IconListTemplateContainer').width(); // 500 - modalInner Width
  const width = parentWidth - bothPadding;
  const iconSize = 54;
  const iconsInLine = parseInt(width / iconSize, 10);

  const iconsInLineWidth = iconSize * iconsInLine;
  const padding = Math.round(
    // eslint-disable-next-line no-mixed-operators
    parseFloat((width - iconsInLineWidth) / 2 + originalPadding - 1)
  );

  $('.iconListContainer').css('padding', `0 ${padding}px`);
  //=============================
}
